// import logo from '../logo.svg';
import React, { useState } from 'react';
import '../App.css';
import expenseIcon from '../assets/icons/DashboardIcons/expense.svg';
import balanceIcon from '../assets/icons/DashboardIcons/balance.svg';
import revenueIcon from '../assets/icons/DashboardIcons/revenue.svg';
import DashboardAmountDetails from '../components/Dashboard/DashboardAmountDetails';
import Wrapper from '../components/global/Wrapper';
import TotalSettlementCard from '../components/Dashboard/TotalSettlementCard';
import TopProductCard from '../components/Dashboard/TopProductCard';
import Overview from '../components/Dashboard/Overview';
import RegisterBusinessCard from '../components/Dashboard/RegisterBusinessCard';
import Button from '../components/global/Button';

const DashboardPage = () => {
  const [activeCard, setActiveCard] = useState('available-balance');

  return (
    <>
      <Wrapper className=' space-y-3 pt-[30px] md:pt-12  md:space-y-8  !mr-0'>
        <div className='hidden border-b-[1px] md:block md:mt-12  border-[#CDD5D5]'></div>
        <div className='pl-[0px] md:pl-[30px] md:pr-[30px]'>
          <RegisterBusinessCard />
        </div>
        <div className='border-b-[1px]  border-[#CDD5D5]' />
        <div className='pl-[0px] text-black md:!pl-[35px]  '>
          <h4 className='inline-block font-poppins rounded-sm  px-2 text-[10px] md:hidden bg-[#049E2621] p-[3px] text-black font-medium mb-2'>
            Dashboard
          </h4>
          <div>
            <h2 className='font-poppins font-semibold text-green text-lg'>Account Summary</h2>
            <p className='font-poppins font-normal text-base text-black'>
              You have no transaction yet.
            </p>
          </div>
        </div>
        <div className='md:hidden border-b-[1px]  border-[#CDD5D5]'></div>

        <div className='md:hidden flex items-center gap-3 overflow-x-scroll'>
          <Button
            onClick={() => setActiveCard('available-balance')}
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'available-balance' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
          >
            Available Balance
          </Button>
          <Button
            onClick={() => setActiveCard('revenue')}
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'revenue' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
          >
            Revenue
          </Button>
          <Button
            onClick={() => setActiveCard('expenses')}
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'expenses' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
          >
            Expenses
          </Button>
          <Button
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'total-settlement' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
            onClick={() => setActiveCard('total-settlement')}
          >
            Total Settlements
          </Button>
          <Button
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'total-products' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
            onClick={() => setActiveCard('total-products')}
          >
            Total Products
          </Button>
          <Button
            theme='outline'
            size='md'
            className={`text-xs whitespace-nowrap w-full font-medium !py-2 ${
              activeCard === 'overall-chart' ? 'bg-[#049E2621]' : 'bg-[#76839624]'
            } `}
            onClick={() => setActiveCard('overall-chart')}
          >
            Overall Chart
          </Button>
        </div>
        <p className=' md:hidden font-poppins text-[10px] text-[#768396] font-normal'>
          Your over transaction activities when sell a product or offer a service or receive
          payment.
        </p>
      </Wrapper>

      <Wrapper className='hidden md:block pl-[0px] space-y-4  md:!pl-[35px]'>
        <div className='pr-[0px] md:pr-[50px]'>
          <div className=' md:grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  gap-4  '>
            <DashboardAmountDetails
              label='Available Balance'
              value='0.00'
              icon={balanceIcon}
              hint='Your current money you have in your wallet or bank account after a transaction'
            />
            <DashboardAmountDetails
              label='Revenue'
              value='0.00'
              icon={expenseIcon}
              hint='The total amount of money you receive into your account when you sell a product or offer a service.'
            />
            <DashboardAmountDetails
              label='Expenses'
              value='0.00'
              icon={revenueIcon}
              hint='The Total amount of money spent out either through transfer of by purchasing a product'
            />
          </div>
          <div className='lg:block xl:grid grid-cols-6 mb-10 gap-4'>
            <section className='col-span-2'>
              <TotalSettlementCard
                label='Total Settlements'
                value='0.00'
                icon={revenueIcon}
                hint='This is the payments or transactions finally settle and clear for customer use or realease into your account'
              />
              <TopProductCard />
            </section>
            <section className='col-span-4'>
              <Overview />
            </section>
          </div>
        </div>
      </Wrapper>

      <div className='block md:hidden'>
        {activeCard === 'overall-chart' && <Overview type='mobile' />}
      </div>

      <div className='block mt-[32px] md:hidden'>
        {activeCard === 'available-balance' && (
          <DashboardAmountDetails label='Available Balance' value='0.00' icon={balanceIcon} />
        )}
      </div>
      <div className='block mt-[32px] md:hidden'>
        {activeCard === 'revenue' && (
          <DashboardAmountDetails label='Revenue' value='0.00' icon={expenseIcon} />
        )}
      </div>
      <div className='block mt-[32px] md:hidden'>
        {activeCard === 'expenses' && (
          <DashboardAmountDetails label='Expenses' value='0.00' icon={revenueIcon} />
        )}
      </div>

      <div className='block mt-[32px] md:hidden'>
        {activeCard === 'total-products' && <TopProductCard type='mobile' />}
      </div>
      <div className='block mt-[32px] md:hidden'>
        {activeCard === 'total-settlement' && (
          <TotalSettlementCard label='Total Settlements' value='0.00' icon={revenueIcon} />
        )}
      </div>
    </>
  );
};

export default DashboardPage;
